import React, { useEffect, useState } from 'react';
import './Hero.css';

const Hero = React.forwardRef((props, ref) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section ref={ref} className="hero">
      <div 
        className="hero-gradient"
        style={{
          background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(167, 139, 250, 0.15), transparent 50%)`
        }}
      />
      
      <div className="hero-content">
        <div className="hero-badge">Desenvolvedor Full Stack & Motion Designer</div>
        
        <h1 className="hero-title">
          <span className="hero-name">Rikelmy</span>
          <span className="hero-name">Cavalcante</span>
        </h1>
        
        <p className="hero-description">
          Transformando ideias em experiências digitais incríveis
        </p>
        
        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number">18</div>
            <div className="stat-label">Anos</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">2+</div>
            <div className="stat-label">Apps Publicados</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">100%</div>
            <div className="stat-label">Dedicação</div>
          </div>
        </div>

        <div className="hero-cta">
          <button className="btn-primary" onClick={() => window.scrollTo({ top: window.innerHeight * 6, behavior: 'smooth' })}>
            Entre em Contato
          </button>
          <button className="btn-secondary" onClick={() => window.scrollTo({ top: window.innerHeight * 3, behavior: 'smooth' })}>
            Ver Projetos
          </button>
          <a 
            href="/curriculo_rikelmy_cavalcante_batista.pdf" 
            download="Curriculo_Rikelmy_Cavalcante.pdf"
            className="btn-download"
          >
            <span className="download-icon">📄</span>
            Baixar Currículo
          </a>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <p>Scroll para explorar</p>
      </div>

      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </section>
  );
});

export default Hero;
